export const tableHeaders = [
    {
      field: 'month',
      headerName: 'Month',
      sortable: true,
      width: 250
    },
    {
      field: 'mpan',
      headerName: 'MPAN',
      sortable: false
    },
    {
      field: 'msp',
      headerName: 'Energy @MSP (kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'gsp',
      headerName: 'Energy @GSP (kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'nbp',
      headerName: 'Energy @NBP (kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'total_non_comm_cost',
      headerName: 'Total Non-Comm Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'weighted_rate_non_comm',
      headerName: 'Total Weighted Non-Comm Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'cost_dist',
      headerName: 'Total DUoS Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'weighted_rate_dist',
      headerName: 'Weighted DUoS Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'cost_govt',
      headerName: 'Total Govt Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'weighted_rate_govt',
      headerName: 'Weighted Govt. Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'cost_trans',
      headerName: 'Total Trans Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'weighted_rate_trans',
      headerName: 'Weighted Trans Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'red_qty',
      headerName: 'DUoS Red (kWh)'
    },
    {
      field: 'red_rate',
      headerName: 'DUoS Red (p/kWh)'
    },
    {
      field: 'red_cost',
      headerName: 'DUoS Red (£)'
    },
    {
      field: 'amber_qty',
      headerName: 'DUoS Amber (kWh)',
      sortable: true,
      width: 250,
    },
    {
      field: 'amber_rate',
      headerName: 'DUoS Amber (p/kWh)',
      sortable: true,
      width: 250,
    },
    {
      field: 'amber_cost',
      headerName: 'DUoS Amber (£)',
      sortable: true,
      width: 250,
    },
    {
      field: 'green_qty',
      headerName: 'DUoS Green (kWh)',
      sortable: true,
      width: 250,
    },
    {
      field: 'green_rate',
      headerName: 'DUoS Green (p/kWh)',
      sortable: true,
      width: 250,
    },
    {
      field: 'green_cost',
      headerName: 'DUoS Green (£)',
      sortable: true,
      width: 250,
    },
    {
      field: 'reactive_qty',
      headerName: 'DUoS Reactive (kVArh)',
      sortable: true,
      width: 250
    },
    {
      field: 'reactive_rate',
      headerName: 'DUoS Reactive (p/kVArh)',
      sortable: true,
      width: 250
    },
    {
      field: 'reactive_cost',
      headerName: 'DUoS Reactive (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'standing_qty',
      headerName: 'DUoS Standing (Days)',
      sortable: true,
      width: 250
    },
    {
      field: 'standing_rate',
      headerName: 'DUoS Reactive (p/Day)',
      sortable: true,
      width: 250
    },
    {
      field: 'standing_cost',
      headerName: 'DUoS Standing (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'capacity_qty',
      headerName: 'DUoS Capacity (kVA)',
      sortable: true,
      width: 250
    },
    {
      field: 'capacity_rate',
      headerName: 'DUoS Capacity (p/kVA/Day)',
      sortable: true,
      width: 250
    },
    {
      field: 'capacity_cost',
      headerName: 'DUoS Capacity (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'ccl_rate',
      headerName: 'CCL Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'ccl_cost',
      headerName: 'CCL Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'ro_rate',
      headerName: 'RO Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'ro_cost',
      headerName: 'RO Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'fit_rate',
      headerName: 'FiT Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'fit_cost',
      headerName: 'FiT Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'cfd_rate',
      headerName: 'CfD Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'cfd_cost',
      headerName: 'CfD Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'cm_rate',
      headerName: 'CM Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'cm_cost',
      headerName: 'CM Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'aahedc_rate',
      headerName: 'AAHEDC Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'aahedc_cost',
      headerName: 'AAHEDC Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'bsuos_rate',
      headerName: 'BSUoS Rate (p/kWh)',
      sortable: true,
      width: 250
    },
    {
      field: 'bsuos_cost',
      headerName: 'BSUoS Cost (£)',
      sortable: true,
      width: 250
    },
    {
      field: 'tnuos_est',
      headerName: 'TNUoS/Triad Estimate (kW)',
      sortable: true,
      width: 250
    },
    {
      field: 'tnuos_rate',
      headerName: 'TNUoS/Triad Rate (£/kW)',
      sortable: true,
      width: 250
    },
    {
      field: 'tnuos_cost',
      headerName: 'TNUoS/Triad Cost (£)',
      sortable: true,
      width: 250
    },
]